module.exports = __webpack_public_path__ + "static/media/google_ads.c77c1b3a.svg";